const swedishCountries = {
    'Sweden': 'Sverige',
    'United States': 'Förenta staterna',
    'Canada': 'Kanada',
    'Mexico': 'Mexiko',
    'Brazil': 'Brasilien',
    'United Kingdom': 'Storbritannien',
    'Germany': 'Tyskland',
    'France': 'Frankrike',
    'Italy': 'Italien',
    'Spain': 'Spanien',
    'Australia': 'Australien',
    'New Zealand': 'Nya Zeeland',
    'China': 'Kina',
    'Japan': 'Japan',
    'India': 'Indien',
    'South Korea': 'Sydkorea',
    'Russia': 'Ryssland',
    'South Africa': 'Sydafrika',
    'Argentina': 'Argentina',
    'Egypt': 'Egypten',
    'Nigeria': 'Nigeria',
    'Kenya': 'Kenya',
    'Saudi Arabia': 'Saudiarabien',
    'Turkey': 'Turkiet',
    'Israel': 'Israel',
    'United Arab Emirates': 'Förenade Arabemiraten',
    'Egypt': 'Egypten',
    'Chile': 'Chile',
    'Peru': 'Peru',
    'Colombia': 'Colombia',
    'Vietnam': 'Vietnam',
    'Thailand': 'Thailand',
    'Indonesia': 'Indonesien',
    'Malaysia': 'Malaysia',
    'Philippines': 'Filippinerna',
    'Singapore': 'Singapore',
    'South Korea': 'Sydkorea',
    'North Korea': 'Nordkorea',
    'Norway': 'Norge',
    'Denmark': 'Danmark',
    'Finland': 'Finland',
    'Iceland': 'Island',
    'Estonia': 'Estland',
    'Latvia': 'Lettland',
    'Lithuania': 'Litauen',
    'Poland': 'Polen',
    'Czech Republic': 'Tjeckien',
    'Slovakia': 'Slovakien',
    'Hungary': 'Ungern',
    'Romania': 'Rumänien',
    'Bulgaria': 'Bulgarien',
    'Greece': 'Grekland',
    'Cyprus': 'Cypern',
    'Portugal': 'Portugal',
    'Ireland': 'Irland',
    'Netherlands': 'Nederländerna',
    'Belgium': 'Belgien',
    'Luxembourg': 'Luxemburg',
    'Switzerland': 'Schweiz',
    'Austria': 'Österrike',
    'Poland': 'Polen',
    'Ukraine': 'Ukraina',
    'Serbia': 'Serbien',
    'Croatia': 'Kroatien',
    'Bosnia and Herzegovina': 'Bosnien och Hercegovina',
    'Slovenia': 'Slovenien',
    'Albania': 'Albanien',
    'Macedonia': 'Makedonien',
    'Kosovo': 'Kosovo',
    'Montenegro': 'Montenegro',
    'Belarus': 'Vitryssland',
    'Moldova': 'Moldavien',
    'Georgia': 'Georgien',
    'Armenia': 'Armenien',
    'Azerbaijan': 'Azerbajdzjan',
    'Kazakhstan': 'Kazakstan',
    'Kyrgyzstan': 'Kirgizistan',
    'Uzbekistan': 'Uzbekistan',
    'Turkmenistan': 'Turkmenistan',
    'Tajikistan': 'Tadzjikistan',
    'Afghanistan': 'Afghanistan',
    'Pakistan': 'Pakistan',
    'Bangladesh': 'Bangladesh',
    'Nepal': 'Nepal',
    'Bhutan': 'Bhutan',
    'Sri Lanka': 'Sri Lanka',
    'Maldives': 'Maldiverna',
    'Myanmar': 'Myanmar',
    'Laos': 'Laos',
    'Cambodia': 'Kambodja',
    'Bangladesh': 'Bangladesh',
    'Malta': 'Malta',
    'Mauritius': 'Mauritius',
    'Jamaica': 'Jamaica',
    'Haiti': 'Haiti',
    'Cuba': 'Kuba',
    'Dominican Republic': 'Dominikanska republiken',
    'Puerto Rico': 'Puerto Rico',
    'Barbados': 'Barbados',
    'Bermuda': 'Bermuda',
    'Saint Lucia': 'Saint Lucia',
    'Grenada': 'Grenada',
    'Antigua and Barbuda': 'Antigua och Barbuda',
    'Saint Vincent and the Grenadines': 'Saint Vincent och Grenadinerna',
    'Saint Kitts and Nevis': 'Saint Kitts och Nevis',
    'Trinidad and Tobago': 'Trinidad och Tobago',
    'Guyana': 'Guyana',
    'Suriname': 'Surinam',
    'Belize': 'Belize',
    'Honduras': 'Honduras',
    'Nicaragua': 'Nicaragua',
    'El Salvador': 'El Salvador',
    'Costa Rica': 'Costa Rica',
    'Panama': 'Panama',
    'Guatemala': 'Guatemala',
    'Dominican Republic': 'Dominikanska republiken',
    'Colombia': 'Colombia',
    'Ecuador': 'Ecuador',
    'Peru': 'Peru',
    'Bolivia': 'Bolivia',
    'Paraguay': 'Paraguay',
    'Uruguay': 'Uruguay',
    'Suriname': 'Surinam',
    'French Guiana': 'Franska Guyana',
    'Venezuela': 'Venezuela',
    'Guyana': 'Guyana'
};

export default swedishCountries;
